import React from 'react';
import { useImageGridReorder } from '../hooks/useImageGridReorder';

export type ListingImageOrderItem =
  | { type: 'existing'; id: string; src: string; url: string }
  | { type: 'new'; id: string; src: string };

export interface ListingImageOrderGridProps {
  items: ListingImageOrderItem[];
  onRemove: (id: string) => void;
  onReorder: (fromIndex: number, toIndex: number) => void;
  title?: string;
}

const ListingImageOrderGrid: React.FC<ListingImageOrderGridProps> = ({
  items,
  onRemove,
  onReorder,
  title = 'İlan Resimleri',
}) => {
  const { containerRef, getItemProps } = useImageGridReorder(onReorder);

  if (items.length === 0) return null;

  return (
    <div className="mb-3">
      <h5 className="card-title mb-3 fw-bold">
        <i className="fas fa-images me-2 text-primary" aria-hidden="true" />
        {title}
      </h5>
      {items.length > 1 && (
        <p className="text-muted small mb-2">Sıralamak için görselleri sürükleyip bırakın.</p>
      )}
      <div className="d-flex flex-wrap gap-3" ref={containerRef}>
        {items.map((item, index) => {
          const itemProps = getItemProps(index);
          return (
            <div
              key={item.id}
              className="position-relative rounded overflow-hidden border bg-light"
              style={{ width: 120, height: 120, ...itemProps.style }}
              draggable={itemProps.draggable}
              onDragStart={itemProps.onDragStart}
              onDragOver={itemProps.onDragOver}
              onDrop={itemProps.onDrop}
              onDragEnd={itemProps.onDragEnd}
              onPointerDown={itemProps.onPointerDown}
              onPointerMove={itemProps.onPointerMove}
              onPointerUp={itemProps.onPointerUp}
              onPointerCancel={itemProps.onPointerCancel}
            >
              {index === 0 && (
                <span className="badge bg-primary position-absolute top-0 start-0 m-1" style={{ zIndex: 2 }}>
                  Kapak
                </span>
              )}
              <img
                src={item.src}
                alt={`İlan fotoğrafı ${index + 1}`}
                className="w-100 h-100"
                style={{ objectFit: 'cover', pointerEvents: 'none' }}
                draggable={false}
                loading="lazy"
              />
              <button
                type="button"
                className="btn btn-danger btn-sm position-absolute top-0 end-0 m-1 sb-listing-image-remove-btn"
                style={{ zIndex: 2 }}
                onClick={() => onRemove(item.id)}
                aria-label="Fotoğrafı kaldır"
              >
                <i className="fas fa-times" aria-hidden="true" />
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListingImageOrderGrid;
